interface RadioContainerProps {
  title?: string;
  subTitle?: string;
  children: React.ReactNode;
  twoLines?: boolean;
}

const RadioContainer: React.FC<RadioContainerProps> = ({
  title,
  subTitle,
  children,
  twoLines,
}) => {
  return (
    <>
      {title && <h3 className='content-bold black'>{title}</h3>}
      {subTitle && (
        <p className='content-normal radio-container-subtitle'>{subTitle}</p>
      )}
      <div className={`interactive-choices ${twoLines ? 'two-lines' : ''}`}>
        {children}
      </div>
    </>
  );
};

export default RadioContainer;
